import React from 'react';
import PropTypes from 'prop-types';

import {
  IonContent,
  IonHeader,
  IonPage,
  IonTitle,
  IonToolbar,
  IonButtons,
  IonLabel,
  IonSearchbar,
  IonList,
  IonItem,
  IonBackButton,
  IonIcon,
  IonModal,
  IonButton,
  IonInput,
  IonItemDivider,
  IonInfiniteScroll,
  IonInfiniteScrollContent,
  IonSpinner,
  IonToast,
  IonText,
  IonProgressBar,
  IonItemSliding,
  IonItemOptions,
  IonItemOption,
} from '@ionic/react';
import { connect } from 'react-redux'
import { close, send, mail, book } from 'ionicons/icons';
import ReactQuill from 'react-quill';
import 'react-quill/dist/quill.snow.css';

import './Program.css';
import ProgramActions from '../../../actions/program';
import ErrorAlert from '../../../components/ErrorAlert';

interface IProps {
  getChild: any;
  geteva: any;
  setData: any;
  changeFields: any;
  sendMessages: any;
  errorForm: any;
  history: any;
  match: any;
}

interface IState {
  showModal: boolean;
  data: any;
}

class Program extends React.Component<IProps, IState> {
  ionInfiniteScrollRefProgram: React.RefObject<HTMLIonInfiniteScrollElement>;
  constructor(props: any) {
    super(props)
    this.ionInfiniteScrollRefProgram = React.createRef<HTMLIonInfiniteScrollElement>();
    this.state = {data: props.data, showModal:false}
  }

  componentDidMount(){
    if(this.state.data.eva.length === 0){
      this.props.getChild({id: this.props.match.params.child}, "get_child");
    }
  }

  UNSAFE_componentWillReceiveProps(nextProps: any){
    this.setState({
      data: nextProps.data
    });

    if (!nextProps.data.loading) {
      if (this.ionInfiniteScrollRefProgram.current) {
        this.ionInfiniteScrollRefProgram.current.complete();
      }
    }
  }

  statusModal(open: boolean, evi: any = null){
    if (open) {
      let fields = this.state.data.fields;
      fields.tutor = this.state.data.doc.filter((person:any) => person.materia === evi.materia)[0];
      fields.subject = evi.materia;
      fields.message = evi.descripcion;
      fields.correoTutor = this.state.data.doc.filter((person:any) => person.materia === evi.materia)[0].correousuario;
      this.props.changeFields(fields);
      this.props.errorForm({errors:{}});
    }

    this.setState({
      showModal: open
    });
  }

  handleSearch(event: any) {
    this.props.setData(event.target.value, "searcheva");
    if (this.state.data.searcheva.length === 0) {
      this.props.setData(1, "pageva");
      this.props.setData([], "eva");
      this.props.geteva({id: this.props.match.params.child, pageva: 1, searcheva: event.target.value}, "get_child_eva");
    }
  }

  Search(event: any) {
    if (this.state.data.searcheva.length > 0) {
      this.props.setData(1, "pageva");
      this.props.setData([], "eva");
      this.props.geteva({id: this.props.match.params.child, pageva: 1, searcheva: this.state.data.searcheva}, "get_child_eva");
    }
  }

  loadMoreItems(){
    if (!this.state.data.loadmoreeva) {
      if (this.ionInfiniteScrollRefProgram.current) {
        this.ionInfiniteScrollRefProgram.current.complete();
      }
    }
    if (this.state.data.loadmoreeva) {
      this.props.geteva({id: this.props.match.params.child, pageva: this.state.data.pageva, searcheva: this.state.data.searcheva}, "get_child_eva");
    }
  }

  handleChange(event: any) {
    let fields = this.state.data.fields;
    fields[event.target.name] = event.target.value;
    this.props.changeFields(fields)
  }

  handleChangeEditor(content: any) {
    let fields = this.state.data.fields;
    fields.message = content;
    this.props.changeFields(fields)
  }

  sendMessage(){
    const fields = this.state.data.fields;
    fields.para = [];
    fields.para.push(this.state.data.fields.tutor);
    fields.sms = {contenido: this.state.data.fields.message, titulo: this.state.data.fields.subject};
    this.props.sendMessages(fields, "sent_messages_tutor");
  }

  handleCustomerClick(url: any) {
    //this.props.history.push(url);
    window.location.replace(url);
  }

  render() {
    const { eva, user, fields, simpleToast, toastMessage, formErrors, error, error401, loading } = this.state.data;
    return (
      <IonPage>
        <ErrorAlert/>
        <IonHeader>
          <IonToolbar color="primary">
            <IonButtons slot="start">
              <IonBackButton defaultHref="/progress" />
            </IonButtons>
            <IonTitle>{ !error && !error401 && user.alumno ? user.alumno : error || error401 ? "Error en la petición":"Cargando..." }</IonTitle>
          </IonToolbar>
          <IonToolbar className="toolbarTint">
            <IonTitle style={ !error && !error401 && user.alumno ? {display: "block"}: {display: "none"}} className="ion-text-center">IB: {user.grado} {user.seccion} - {user.turno}</IonTitle>
          </IonToolbar>
          <IonToolbar color="primary">
            <IonSearchbar placeholder="Buscar..." type="search" inputmode="search" value={this.state.data.searcheva } onClick={this.Search.bind(this)} onIonChange={this.handleSearch.bind(this)}></IonSearchbar>
          </IonToolbar>
        </IonHeader>
        <IonContent fullscreen>

        <IonModal isOpen={this.state.showModal} >
          <IonHeader>
            <IonToolbar color="primary">
              <IonButtons slot="end">
                <IonButton onClick={this.sendMessage.bind(this)} disabled={loading}>
                  <IonIcon icon={send} />
                </IonButton>
                <IonButton onClick={this.statusModal.bind(this, false)} disabled={loading}>
                  <IonIcon icon={close}/>
                </IonButton>
              </IonButtons>
              <IonTitle>Nueva notificación</IonTitle>
            </IonToolbar>
          </IonHeader>

          <IonToast
            isOpen={simpleToast}
            buttons={[
              {
                text: 'Ok',
                role: 'cancel'
              }
            ]}
            message={`${toastMessage}`}
            duration={3000}
          />

          <IonContent >
            <IonProgressBar style={ loading ? {display: 'block'} : {display: 'none'}} type="indeterminate"></IonProgressBar>
            <IonList id="inside-mce">
              <IonItem>
                <IonLabel>Para:</IonLabel>
                <IonInput placeholder="para"  value={fields.correoTutor} disabled></IonInput>
              </IonItem>
              <IonItem>
                <IonInput name="subject" placeholder="Asunto"  value={fields.subject || "" } onIonChange={this.handleChange.bind(this)}></IonInput>
              </IonItem>
              {formErrors.errors && formErrors.errors.subject && (
                <IonText color="danger" className="ion-padding-start">
                  <small>{formErrors.errors.subject}</small>
                </IonText>
              )}
              <IonItemDivider>Redactar mensaje</IonItemDivider>
              <ReactQuill theme="snow" value={fields.message || ""} onChange={this.handleChangeEditor.bind(this)}/>
              {formErrors.errors && formErrors.errors.message && (
                <IonText color="danger" className="ion-padding-start">
                  <small>{formErrors.errors.message}</small>
                </IonText>
              )}
            </IonList>
          </IonContent>
        </IonModal>

        <div style={ loading ? {display: "block", paddingTop: '10%'} : {display: "none"}} className="ion-text-center"><IonSpinner name="circles" color="primary"/></div>
        <h1 style={error || error401 && !loading ? {display: "block"} : {display: "none"}} className="ion-text-center">Error en el sistema, consulte con el administador de la aplicación.</h1>
        <h1 style={eva.length === 0 && !error && !error401 && !loading ? {display: "block"} : {display: "none"}} className="ion-text-center">No hay registros</h1>
        <IonList style={error || error401 && !loading ? {display: "none"} : {display: "block"} }>
          {eva.map((val:any, key:any) => {
            return (
              <IonItemSliding key={key}>
                <IonItem key={key}>
                  <IonLabel>
                    <h2>{val.materia}</h2>
                    <p>Actividad: {val.grupo}</p>
                    <p>Titulo: {val.descripcion}</p>
                    <p>Nota: {val.valor}</p>
                  </IonLabel>
                </IonItem>
                <IonItemOptions side="end">
                  <IonItemOption onClick={this.handleCustomerClick.bind(this, `/progress/${ user.carnet }/pro/${ val.nid }/guide`)} color="medium"><IonIcon icon={book} color="light" size="large" slot="end"/></IonItemOption>
                  <IonItemOption className="colorMedium" onClick={this.statusModal.bind(this, true, val)}><IonIcon icon={mail} size="large" color="light"/></IonItemOption>
                </IonItemOptions>
              </IonItemSliding>
            );
          })}
        </IonList>
        <IonInfiniteScroll threshold="50px" ref={this.ionInfiniteScrollRefProgram}  onIonInfinite={this.loadMoreItems.bind(this)}>
          <IonInfiniteScrollContent
            loadingSpinner="bubbles"
            loadingText="Cargando mas información...">      
          </IonInfiniteScrollContent>
        </IonInfiniteScroll>
        </IonContent>
      </IonPage>
    );
  };
}

const mapStateToProps = (state: any) => {
  return {
    data: state.data,
    getChild: PropTypes.func.isRequired,
    geteva: PropTypes.func.isRequired,
    setData: PropTypes.func.isRequired,
    changeFields: PropTypes.func.isRequired,
    sendMessages: PropTypes.func.isRequired,
    errorForm: PropTypes.func.isRequired
  }
}

const mapDispatchToProps = (dispatch: any) => {
  return {
    getChild: (fields: any, typeOptions: string) => dispatch(ProgramActions.getChild(fields, typeOptions)),
    geteva: (fields: any, typeOptions: string) => dispatch(ProgramActions.geteva(fields, typeOptions)),
    setData: (item: any, name: string) => dispatch(ProgramActions.setData(item, name)),
    changeFields: (fields: any) => dispatch(ProgramActions.changeFields(fields)),
    sendMessages: (fields: any, typeOptions: string) => dispatch(ProgramActions.sendMessages(fields, typeOptions)),
    errorForm: (errors: any) => dispatch(ProgramActions.errorForm(errors)),
  }
};

export default connect(mapStateToProps, mapDispatchToProps)(Program);
